export default __webpack_public_path__ + "static/media/stripe-up.95aa42f5.svg";